export enum EnumRowState {
  UNCHANGED = "UNCHANGED",
  MODIFIED = "MODIFIED",
  DELETED = "DELETED",
}
